@if (globalMessage(); as globalMessage) {
  <div
    class="global-message {{ globalMessage.status }} {{
      isMarginTop ? 'with-margin-top' : ''
    }} {{ isMarginBottom ? 'with-margin-bottom' : '' }}"
  >
    <spen-flash-message>
      <div>{{ globalMessage.message.general }}</div>
      @if (globalMessage.message.hint_link; as hintLink) {
        <div class="hint-link">
          {{ hintLink.label }}：<a
            spenLink
            href="{{ hintLink.url }}"
            target="_blank"
            rel="noopener noreferrer"
            >{{ hintLink.title }}</a
          >
        </div>
      }
      @if (globalMessage.message.displayInquiry) {
        <div class="inquiry">
          <p>■先生専用電話窓口</p>
          <p>フリーダイヤル: 0120-755-640</p>
          <p>平日8:00〜19:00 土曜8:00〜17:00 ※日曜祝日、年末・年始を除く</p>
        </div>
      }
    </spen-flash-message>
  </div>
}
